import { Component, OnInit, Input, HostListener } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { DocDefPrimLibService } from '../../../doc-def-prim-lib.service';
import { DOData, NJDocData, modalParams, ModalParamsElem } from "../../DOData";
import { SectionTableComponent, DOTextBoxComponent } from 'projects/doc-def-prim-lib/src/public-api';

@Component({
  selector: 'cy-generic-text-body-reader',
  templateUrl: './generic-text-body-reader.component.html',
  styleUrls: ['./generic-text-body-reader.component.css']
})

export class GenericTextBodyReaderComponent implements OnInit {

    public loaderKey: string;
    public apiController: string;

    @Input() modal_title: string = "";
    @Input() selectedDiag: string;

    tabTemplateCode: string = "";
    private tabCode: string;
    private tabCodeFooter: string;

    public listDocdata: Array<Array<DOData>>;
    public listDocdataFooter: Array<Array<DOData>>;
    private strDocDefTypeSubCode: string = "Wrappers";
    private gridTemplateCode: string = "";

    private primitives: Array<Array<DOData>>;
    private lstPrimitives: Array<SectionTableComponent> = [];


    private _canClick: boolean = true;

    public isDataAvailable: boolean = false;
    private diagnosisData: Array<DOData> = new Array<DOData>();

    private primitivesGrid: SectionTableComponent;
    private primitives2: Array<DOData>;

    public validationMsgs: string = "";

    private selectedRow: Array<DOData> = new Array<DOData>();


    constructor(public activeModal: NgbActiveModal, private dataLib: DocDefPrimLibService) { }

    public returnResponse() {
        this.activeModal.close(this.selectedRow);
    }
    public dismiss() {
        this.activeModal.dismiss(new Array<NJDocData>());
    }
    mobHeight: number;
    mobWidth: number;
    height: Number = 50;
    @HostListener('window:resize', ['$event'])
    onResize(event) {
        this.mobHeight = event.target.innerHeight;
        this.mobWidth = event.target.innerWidth;
        this.height = this.mobHeight * 0.5;
    }

    ngOnInit() {
        this.loaderKey = "Wrappers";
        this.tabCode = "Wrappers_Tab_GenericTextBody";
        this.tabCodeFooter = "Wrappers_Tab_FooterGenTextBo";

        this.initSetup();
    }

    initSetup() {
        //this.listVM.loaderKey = this.loaderKey;

        this.loadReader();
    }

    loadReader() {
        var params: modalParams = new modalParams();
        params.tabTemplateCode = this.tabCode;
        params.loaderKey = this.loaderKey;
        params.strDocDefTypeSubCode = this.strDocDefTypeSubCode;
        params.gridTemplateCode = this.gridTemplateCode;
        var elem: ModalParamsElem = new ModalParamsElem();
        elem.value = this.selectedDiag;
        elem.param = "TxtBody";
        params.lstModalParams.push(elem);
        this.dataLib.loadTab(params)
            .subscribe(
                (ret: boolean) => {
                    if (ret) {
                        //this.listVM = this.data.WelcomeVM;
                        let localListDocdata = new Array<Array<DOData>>();
                        for (let lstData of this.dataLib.TabVM.docdata) {
                            let newLst = new Array<DOData>();
                            for (let doData of lstData) {
                                newLst.push(DocDefPrimLibService.createNew(doData));
                            }
                            localListDocdata.push(newLst)
                        }
                        this.listDocdata = localListDocdata;
                    }
                },
                (err: any) => console.log(err),
                () => {
                    console.log('Complete- loadReader')
                    // this does not work in IE. Method used to make IE work is depricated.
                    // When we go to a real browser we should use commented out code.
                    //window.dispatchEvent(new Event('resize'));
                    //var resizeEvent = window.document.createEvent('UIEvents');
                    //resizeEvent.initUIEvent('resize', true, false, window, 0);
                    //window.dispatchEvent(resizeEvent);

                    //var resizeEvent = window.document.createEvent('UIEvents');
                    //resizeEvent.initUIEvent('resize', true, false, window, 0);
                    //window.dispatchEvent(resizeEvent);

                    //if (typeof (Event) === 'function') {
                    //    // modern browsers
                    //    window.dispatchEvent(new Event('resize'));
                    //} else {
                    //    //This will be executed on old browsers and especially IE
                    //    var resizeEvent = window.document.createEvent('UIEvents');
                    //    resizeEvent.initUIEvent('resize', true, false, window, 0);
                    //    window.dispatchEvent(resizeEvent);
                    //}
                    //this.ModalWait.close("");
                    this.loadFooter(false);
                }
            );

        //this.cyService.loadTemplatesDM(this.tabCode, this.loaderKey, this.apiController)
        //    .subscribe(
        //        (ret: boolean) => {
        //            if (ret) {
        //                this.listVM = this.cyService.DiagMedVM;
        //                let localListDocdata = new Array<Array<DOData>>();
        //                for (let lstData of this.cyService.DiagMedVM.docdata) {
        //                    let newLst = new Array<DOData>();
        //                    for (let doData of lstData) {
        //                        newLst.push(DocDefPrimLibService.createNew(doData));
        //                    }

        //                    localListDocdata.push(newLst);
        //                }
        //                this.listDocdata = localListDocdata;
        //                this.listVM.docdata = localListDocdata;
        //            }
        //        },
        //        (err: any) => console.log(err),
        //        () => {
        //            console.log('Complete - loadSearchDiagnosis')
        //            // this does not work in IE. Method used to make IE work is depricated.
        //            // When we go to a real browser we should use commented out code.
        //            //window.dispatchEvent(new Event('resize'));
        //            //var resizeEvent = window.document.createEvent('UIEvents');
        //            //resizeEvent.initUIEvent('resize', true, false, window, 0);
        //            //window.dispatchEvent(resizeEvent);
        //            var resizeEvent = window.document.createEvent('UIEvents');
        //            resizeEvent.initUIEvent('resize', true, false, window, 0);
        //            window.dispatchEvent(resizeEvent);
        //            //this.ModalWait.close("");

        //            this.loadFooter(false);
        //        }
        //    );
    }

    loadFooter(validate: boolean) {
        var params: modalParams = new modalParams();
        params.tabTemplateCode = this.tabCodeFooter;
        params.loaderKey = this.loaderKey;
        params.strDocDefTypeSubCode = this.strDocDefTypeSubCode;
        params.gridTemplateCode = "";
        //var elem: ModalParamsElem = new ModalParamsElem();
        //elem.value = this.zip;
        //elem.param = this.zipTemplateCode;
        //params.lstModalParams.push(elem);
        this.dataLib.loadTab(params)
            .subscribe(
                (ret: boolean) => {
                    if (ret) {
                        //this.listVM = this.data.WelcomeVM;
                        let localListDocdata = new Array<Array<DOData>>();
                        for (let lstData of this.dataLib.TabVM.docdata) {
                            let newLst = new Array<DOData>();
                            for (let doData of lstData) {
                                newLst.push(DocDefPrimLibService.createNew(doData));
                            }
                            localListDocdata.push(newLst)
                        }
                        this.listDocdataFooter = localListDocdata;

                        this.isDataAvailable = true;
                    }
                },
                (err: any) => console.log(err),
                () => {
                    console.log('Complete- loadReaderFooter')
                    // this does not work in IE. Method used to make IE work is depricated.
                    // When we go to a real browser we should use commented out code.
                    //window.dispatchEvent(new Event('resize'));
                    //var resizeEvent = window.document.createEvent('UIEvents');
                    //resizeEvent.initUIEvent('resize', true, false, window, 0);
                    //window.dispatchEvent(resizeEvent);

                    //var resizeEvent = window.document.createEvent('UIEvents');
                    //resizeEvent.initUIEvent('resize', true, false, window, 0);
                    //window.dispatchEvent(resizeEvent);

                    if (typeof (Event) === 'function') {
                        // modern browsers
                        window.dispatchEvent(new Event('resize'));
                    } else {
                        //This will be executed on old browsers and especially IE
                        var resizeEvent = window.document.createEvent('UIEvents');
                        resizeEvent.initUIEvent('resize', true, false, window, 0);
                        window.dispatchEvent(resizeEvent);
                    }
                    this.checkValidationMessages(validate);

                    if (!validate) {
                        //this.finishLoad();
                    }
                }
            );

        //this.cyService.loadTemplatesFS(this.tabCodeFooter, this.loaderKey, this.apiController, true)
        //    .subscribe(
        //        (ret: boolean) => {
        //            if (ret) {
        //                this.listVM = this.cyService.DiagMedVM;
        //                let localListDocdata = new Array<Array<DOData>>();
        //                for (let lstData of this.cyService.DiagMedVM.docdata) {
        //                    let newLst = new Array<DOData>();
        //                    for (let doData of lstData) {
        //                        newLst.push(DocDefPrimLibService.createNew(doData));
        //                    }

        //                    localListDocdata.push(newLst);
        //                }
        //                this.listDocdataFooter = localListDocdata;
        //                this.listVM.docdata = localListDocdata;

        //                this.isDataAvailable = true;
        //            }
        //        },
        //        (err: any) => console.log(err),
        //        () => {
        //            console.log('Complete - loadFooter')
        //            // this does not work in IE. Method used to make IE work is depricated.
        //            // When we go to a real browser we should use commented out code.
        //            //window.dispatchEvent(new Event('resize'));
        //            //var resizeEvent = window.document.createEvent('UIEvents');
        //            //resizeEvent.initUIEvent('resize', true, false, window, 0);
        //            //window.dispatchEvent(resizeEvent);
        //            var resizeEvent = window.document.createEvent('UIEvents');
        //            resizeEvent.initUIEvent('resize', true, false, window, 0);
        //            window.dispatchEvent(resizeEvent);
        //            //this.ModalWait.close("");

        //            this.checkValidationMessages(validate);

        //            if (!validate) {
        //                //this.finishLoad();
        //            }
        //        }
        //    );
    }

    checkValidationMessages(validate: boolean) {
        if (validate) {
            let txtErrMsgs: DOData = this.getDODataFromFooter("Wrappers_FooterGenTextBo_TOSection_FooterTextBodyS_TextBox_FooterGenErrorM");
            this.validationMsgs = txtErrMsgs.njDocData.dataValue;
        }
        else {
            this.validationMsgs = "";
        }
    }

    getDOData(templateCode: string) {
        let objDOData = null;
        this.listDocdata.forEach(ldo => {
            ldo.forEach(d => {
                if (d.njDocDefTemplate.templateCode == templateCode) {
                    objDOData = d;
                }
            });
        });
        return objDOData;
    }

    getDODataFromFooter(templateCode: string) {
        let objDOData = null;
        this.listDocdataFooter.forEach(ldo => {
            ldo.forEach(d => {
                if (d.njDocDefTemplate.templateCode == templateCode) {
                    objDOData = d;
                }
            });
        });
        return objDOData;
    }

    onClickButton(d: DOData) {
        let _this = this;
        switch (d.njDocDefTemplate.tType) {
            case "Button":
                switch (d.njDocDefTemplate.templateCode) {
                    case "Wrappers_GenericTextBody_TOSection_TextBodySection_Button_OK":
                        //this.activeModal.close(d.njDocDefTemplate.templateCode);
                        //let result: DOTextBoxComponent = this.primitivesGrid.TextBoxComponents.filter(t => t.DocDefTemplate.templateCode == "Wrappers_GenericTextBody_TOSection_TextBodySection_TextBox_TextBodyTextAre_37493")[0];
                        //if (result) {
                        this.sendTxtBody();
                        //}
                        break;
                    case "Wrappers_GenericTextBody_TOSection_TextBodySection_Button_Cancel":
                        this.activeModal.close(d.njDocDefTemplate.templateCode);
                        break;
                }
                break;
        }
    }

    // Send text input back to calling component
    sendTxtBody() {
        //on error return empty array
        this.selectedRow = new Array<DOData>();
        // find grid
        //let lstGrid: Array<DOData>;
        //for (var i: number = 0; i < this.listDocdata.length; i++) {
        //    lstGrid = this.listDocdata[i].filter(function (item) {
        //        return item.njDocDefTemplate.tType == "Grid1"
        //    });
        //};
        ////find diag data
        //let lstGridData: Array<NJDocData> = new Array<NJDocData>();
        //if (lstGrid.length == 1) {
        //    //get grid data
        //    lstGridData = lstGrid[0].lstDocData;
        //    // get selected row from col of diag key and value selected
        //    // find template of key from template code in custom paramater
        //    let templateCodeKey = lstGrid[0].customParameters.KeyColumnField;
        //    let lstTemplate = lstGrid[0].lstChildDocDefTemplate.filter(function (item) {
        //        return item.templateCode == templateCodeKey;
        //    });
        //    if (lstTemplate.length == 1) {
        //        // find template id of key
        //        let docDefTemplateID = lstTemplate[0].docDefTemplateID;
        //        // get NJDocData of selected item 
        //        let lstdata = lstGridData.filter(function (item) {
        //            return item.docDefTemplateID == docDefTemplateID && item.dataValue == selectedDiag[0].toString();
        //        });
        //        // get the selected row using docDefDataRowID
        //        if (lstdata.length == 1) {
        //            for (var item of lstGridData) {
        //                if (item.docDefDataRowID == lstdata[0].docDefDataRowID) {
        //                    let doData = new DOData();
        //                    doData.njDocData = item;
        //                    let lstTemplate = lstGrid[0].lstChildDocDefTemplate.filter(function (item1) {
        //                        return item1.docDefTemplateID == item.docDefTemplateID;
        //                    });
        //                    if (lstTemplate.length == 1) {
        //                        doData.njDocDefTemplate = lstTemplate[0];
        //                    }
        //                    doData.njDocDefTemplate
        //                    this.selectedRow.push(doData);
        //                }
        //            }
        //        }
        //    }
        //}

        // Diagnosis Comment
        let txtDiagComment: DOTextBoxComponent = this.primitivesGrid.TextBoxComponents.filter(t => t.DocDefTemplate.templateCode == "Wrappers_GenericTextBody_TOSection_TextBodySection_TextBox_TextBodyTextAre_37493")[0];
        let doDataDiagComment = new DOData();
        doDataDiagComment.njDocData = txtDiagComment.DocData;
        doDataDiagComment.njDocDefTemplate = txtDiagComment.DocDefTemplate;
        this.selectedRow.push(doDataDiagComment);

        this.returnResponse();
    }

    closeModal() {
        this.activeModal.close("Wrappers_GenericTextBody_TOSection_TextBodySection_Button_OK");
    }

    onSection_tableAfterViewInit(c: SectionTableComponent) {
        if (c.TextBoxComponents.first != undefined &&
            c.TextBoxComponents.first.DocDefTemplate.templateCode == "Wrappers_GenericTextBody_TOSection_TextBodySection_TextBox_TextBodyTextAre_37493") {
            this.primitivesGrid = c;
            //this.primitives = c.getPrimitives();
        }
    }


    sectionGrid_tableAfterViewInit_footer(c: SectionTableComponent) {
    }
}
